import { Spin } from 'antd';

export default Spin;



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/spin.js